import { StyleSheet, Text, View } from 'react-native'

// styles
import { colorPalette, globalStyles } from '../../static/styles/global'

// helpers
import { formatMessageDate } from '../../helpers/globalHelper'
//translation
import { useTranslation } from 'react-i18next'

type HomeMessagesProps = {
  message: string
  reply?: string | null
  sentMessageLabel: string
  sentMessageDate?: string
  replyMessageLabel: string
  replyMessageDate?: string
  initiatorType?: 'E' | 'A'
}

const HomeMessages = ({
  message,
  reply,
  sentMessageLabel,
  sentMessageDate,
  replyMessageLabel,
  replyMessageDate,
  initiatorType
}: HomeMessagesProps): JSX.Element => {
  const { t } = useTranslation()
  return (
    <View style={[globalStyles.mt3]}>
      <View>
        <View
          style={[
            globalStyles.hDirection,
            globalStyles.hBetweenItems,
            globalStyles.mb1,
            styles.rightIndent,
            styles.labelGap
          ]}
        >
          <Text
            style={[
              globalStyles.text,
              globalStyles.grayTextColor,
              globalStyles.fs12
            ]}
          >
            {sentMessageLabel}
          </Text>
          <Text
            style={[
              globalStyles.text,
              globalStyles.grayTextColor,
              globalStyles.fs12
            ]}
          >
            {formatMessageDate(sentMessageDate)}
          </Text>
        </View>
        <View style={[styles.messageBox, styles.rightIndent]}>
          <Text style={[globalStyles.text, globalStyles.blackTextColor]}>
            {message}
          </Text>
        </View>
        <View>
          {!reply && initiatorType === 'E' && (
            <Text
              style={[
                globalStyles.text,
                globalStyles.fwLightItalic,
                globalStyles.fs12,
                styles.labelGap,
                { marginTop: 2 }
              ]}
            >
              {t('delivered administrator')}
            </Text>
          )}
        </View>
      </View>
      {reply && (
        <View style={[globalStyles.mt4]}>
          <View
            style={[
              globalStyles.hDirection,
              globalStyles.hBetweenItems,
              globalStyles.mb1,
              styles.leftIndent,
              styles.labelGap
            ]}
          >
            <Text
              style={[
                globalStyles.text,
                globalStyles.grayTextColor,
                globalStyles.fs12
              ]}
            >
              {replyMessageLabel}
            </Text>
            <Text
              style={[
                globalStyles.text,
                globalStyles.grayTextColor,
                globalStyles.fs12
              ]}
            >
              {formatMessageDate(replyMessageDate)}
            </Text>
          </View>
          <View style={[styles.messageBox, styles.replyBox, styles.leftIndent]}>
            <Text style={[globalStyles.text, globalStyles.blackTextColor]}>
              {reply}
            </Text>
          </View>
        </View>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  messageBox: {
    backgroundColor: colorPalette.lightBlue,
    borderRadius: 10,
    paddingVertical: 10,
    paddingHorizontal: 16
  },
  replyBox: {
    backgroundColor: colorPalette.light,
    marginRight: 0
  },
  msgRequest: {
    marginRight: 60
  },
  msgResponse: {
    marginLeft: 60
  },
  rightIndent: {
    marginRight: 60
  },
  leftIndent: {
    marginLeft: 60
  },
  labelGap: { paddingHorizontal: 2 }
})

export default HomeMessages
